/**
=========================================================
* Clifford Inu
=========================================================
*/

export default {
  defaultProps: {
    underline: "none",
    color: "inherit",
  },
};
